import { render, staticRenderFns } from "./DiscoverFilters.vue?vue&type=template&id=5cd6d65e&scoped=true&"
import script from "./DiscoverFilters.vue?vue&type=script&lang=ts&"
export * from "./DiscoverFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DiscoverFilters.vue?vue&type=style&index=0&id=5cd6d65e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6d65e",
  null
  
)

export default component.exports